import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function normalizeCustomerName(name: string): string {
  return name
    .trim()                   
    .toLowerCase()            
    .normalize('NFD')         
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ');     
}

export function checkTabNameExists(customerName: string, existingTabs: any[]): boolean {
  const normalizedName = normalizeCustomerName(customerName);
  return existingTabs.some(tab => 
    tab.isOpen && normalizeCustomerName(tab.customerName) === normalizedName
  );
}

export function isValidCustomerName(customerName: string): boolean {
  return customerName.trim() !== ''; // validates if the customer name is not empty or just whitespace
}

const LEGACY_QUICK_SALE_PREFIXES = ['Quick Sale', 'Venta Rápida'] as const;

export type QuickSaleTabLike = {
  isQuickSale?: boolean | null;
  customerName?: string;
};

export function isQuickSaleName(customerName: string, quickSaleText?: string): boolean {
  if (!customerName) return false;

  const prefixes = new Set<string>(LEGACY_QUICK_SALE_PREFIXES);
  if (quickSaleText) prefixes.add(quickSaleText);

  return [...prefixes].some((prefix) => customerName.startsWith(prefix));
}

export function isQuickSaleTab(
  tab: QuickSaleTabLike | null | undefined,
  quickSaleText?: string
): boolean {
  if (!tab) return false;
  if (typeof tab.isQuickSale === 'boolean') return tab.isQuickSale;
  return isQuickSaleName(tab.customerName ?? '', quickSaleText);
}